import { render, staticRenderFns } from "./FooterMenuForceclub.vue?vue&type=template&id=6310b6ef&scoped=true&"
import script from "./FooterMenuForceclub.vue?vue&type=script&lang=js&"
export * from "./FooterMenuForceclub.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenuForceclub.vue?vue&type=style&index=0&id=6310b6ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310b6ef",
  null
  
)

export default component.exports